import { ElectionDayData } from '../ElectionDayWidgets/types'
import {
    ElectorateMessage,
    PartyMessage,
    PoliticianMessage,
    PollieRaterItem,
    ProfilePictureItem,
    ProfilePictureMessage,
} from '../PollieRater/types'
import {
    ContentfulMessage,
    FieldType,
    FieldValue,
    FileType,
    LinkType,
} from '../types'
import { PollieRaterMessages } from './types'

// Typeguards
export const isFieldType = (
    field: FieldType | FieldValue,
): field is FieldType => {
    if (typeof field !== 'object') {
        return false
    }
    return 'en-US' in field
}

export const isFileType = (field: FieldValue): field is FileType => {
    return typeof field === 'object' && 'url' in field
}

export const isLinkType = (field: FieldValue): field is LinkType => {
    return typeof field === 'object' && 'sys' in field
}

export const isProfilePictureItem = (
    item: PollieRaterItem,
): item is ProfilePictureItem => {
    return item.contentType === 'Asset'
}

export const isPoliticianMessage = (
    message: PollieRaterMessages,
): message is PoliticianMessage => {
    return (
        message.sys.type === 'Entry' &&
        message.sys.contentType?.sys.id === 'politician'
    )
}

export const isPartyMessage = (
    message: PollieRaterMessages,
): message is PartyMessage => {
    return (
        message.sys.type === 'Entry' &&
        message.sys.contentType?.sys.id === 'party'
    )
}

export const isElectorateMessage = (
    message: PollieRaterMessages,
): message is ElectorateMessage => {
    return (
        message.sys.type === 'Entry' &&
        message.sys.contentType?.sys.id === 'electorate'
    )
}

// This needs to change if we ever have anything other then profile pictures for assets.
// We will need to use tags to specify non profile pictures or images, but given how much extra effort that takes
// Let's leave it like this for now.
export const isProfilePictureMessage = (
    message: PollieRaterMessages,
): message is ProfilePictureMessage => {
    return message.sys.type === 'Asset'
}

export const isDeletedMessage = (message: ContentfulMessage) => {
    return (
        (message.sys.type === 'DeletedAsset' ||
            message.sys.type === 'DeletedEntry') &&
        'id' in message.sys
    )
}

export const isPollieRaterMessage = (
    message: ElectionDayData | PollieRaterMessages | undefined,
): message is PollieRaterMessages => !message || 'fields' in message
